import React, { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, TextField, Typography, Unstable_Grid2 as Grid } from '@mui/material';

import { ValidatedTextFieldNext } from 'components';
import ChangePassword from './ChangePassword';
import theme from 'theme';

const Access: FC = () => {
  const [passwordOpen, setPasswordOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <Fragment>
      <Grid container>
        <Grid xs={3}>
          <Typography variant="h6">{t('common:access')}</Typography>
        </Grid>
        <Grid xs={9} container spacing={2}>
          <Grid xs={6}>
            <ValidatedTextFieldNext
              label={t('user:email')}
              name="email_address"
              margin="none"
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid xs container alignItems="center">
            <Grid xs>
              <TextField
                variant="standard"
                fullWidth
                margin="none"
                type="password"
                value="Dummy Text"
                label={t('common:password')}
                inputProps={{ disabled: true }}
                sx={{
                  Input: {
                    backgroundColor: theme.palette.grey[200],
                    padding: theme.spacing(2),
                  },
                }}
              />
            </Grid>
            <Grid xs={3} marginTop={2}>
              <Button
                variant="outlined"
                color="primary"
                fullWidth
                onClick={() => setPasswordOpen(true)}
              >
                {t('common:change')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <ChangePassword open={passwordOpen} onClose={() => setPasswordOpen(false)} />
    </Fragment>
  );
};

export default Access;
